export const GetPopUpAndOrders =
  ({ RestService, HandleError }) =>
  async (id) => {
    try {
      return await RestService.get(`/pop-ups/accounting/${id}/orders`)
    } catch (error) {
      HandleError({ error })
    }
  }
